import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import DefaultHeader from "../../shared/DefaultHeader";
import DefaultFooter from "../../shared/DefaultFooter";
import { useSelector } from "react-redux";
import LoadingFallback from "../../components/elements/LoadingFallback";

const FrontLayout = () => {
  const navigate = useNavigate()
  const session = useSelector((state) => state.authProvider.session);
  const Profile = useSelector((state) => state?.profile?.data);

  const isAuthenticated = session?.status === "authorized" && !!Profile?._id;

  // navigate to dashboard if already authenticated
  useEffect(() => { 
    if (isAuthenticated && window.location.pathname !== "/" && window.location.pathname !== "/auth/callback") {
      navigate('/dashboard') 
    }
  }, [isAuthenticated])

  if ((session?.status === "loading" || isAuthenticated) && window.location.pathname !== "/" && window.location.pathname !== "/auth/callback") {
    // Don’t render header/sidebar until auth check finishes
    return (
      <div className="flex h-screen items-center justify-center">
        <LoadingFallback />
      </div>
    );
  }

  return (
    <>
      <DefaultHeader />
        <Outlet />
      <DefaultFooter />
    </>
  );
};

export default FrontLayout;
